import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Grid,
  Paper,
  Typography,
  Button,
  Box,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import { useDispatch, useSelector } from "react-redux";

import PaymentIcon from "@material-ui/icons/Payment";
import CenterFocusWeakIcon from "@material-ui/icons/CenterFocusWeak";
import FlashOnIcon from "@material-ui/icons/FlashOn";
import SecurityIcon from "@material-ui/icons/Security";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";

import CircularProgresss from "views/components/CircularProgress/CircularProgress";
import ToastModal from "views/components/ToastModal";

import SubHeader from "components/UpdateUi/SubHeader/SubHeader";

import brandTheme from "brandTheme/Theme";

import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import { QRCodeSVG } from "qrcode.react";
import { saveUserCurrentPaymentDetails } from "store/reducers/login/LoginSlice";

const useStyles = makeStyles((theme) => ({
  container: {
    width: "92%",
    margin: "0 auto",
    minHeight: "85vh",
  },

  paymentCard: {
    marginTop: 20,
    borderRadius: 20,
    overflow: "hidden",
  },

  header: {
    background: `linear-gradient(
      135deg,
      ${brandTheme.mainColor},
      ${brandTheme.mainColor}
    )`,
    color: "#fff",
    padding: 25,
    textAlign: "center",
  },

  amountCard: {
    margin: 20,
    padding: 20,
    textAlign: "center",
    borderRadius: 12,
    background: "#fafafa",
  },

  amountValue: {
    color: brandTheme.mainColor,
    fontWeight: 700,
    fontSize: 32,
  },

  tabContainer: {
    padding: "0 20px 20px",
  },

  activeButton: {
    background: `${brandTheme.mainColor} !important`,
    color: "#fff !important",
  },

  inactiveButton: {
    border: `1px solid ${brandTheme.mainColor} !important`,
    color: `${brandTheme.main} !important`,
  },

  qrWrapper: {
    textAlign: "center",
    padding: 30,
  },

  qrImage: {
    width: 250,
    maxWidth: "100%",
    borderRadius: 12,
  },

  infoCard: {
    padding: 15,
    textAlign: "center",
    borderRadius: 12,
  },

  footer: {
    textAlign: "center",
    padding: 15,
    color: "#666",
  },
}));

const PaymentOptions = () => {
  const classes = useStyles();

const navigate = useNavigate();
const location = useLocation();
  const dispatch = useDispatch();
const { authToken } = useSelector(
  (state) => state.login.authData
);

const {
  loanNumber,
  amount,
  receiptPurpose,
  repaymentType,
  remarks,
  provider = [],
} = location.state || {};

const [activeTab, setActiveTab] =
  useState("");

const [callInProgress, setCallInProgress] =
  useState(false);

const [toast, setToast] =
  useState(false);

const [toastMessage, setToastMessage] =
  useState("");

const [toastMessageType, setToastMessageType] =
  useState("");

const [qrData, setQrData] =
  useState(null);
  const toastUpdate = (
  type,
  message,
  showToast
) => {
  setToastMessageType(type);
  setToastMessage(message);
  setToast(showToast);
};
const initiatePayment = async (
  selectedProvider
) => {
  try {
    setCallInProgress(true);

    const payload = {
      loanAccountNumber: loanNumber,
      amount,
      remarks,
      tokenRequired: selectedProvider === "AU_UPI" ? true : false,
      furl:window.location.origin + "/PaymentFailed",
      surl:window.location.origin + "/PaymentSuccess"
    };

    if (selectedProvider === "AU_UPI") {
      payload.tokenRequired = true;
    }

    const result = await apiHandler({
      url:
        endpoint.USESR_INITIATE_PAYMENT_API,
      method: "POST",
      authToken,
      data: payload,
    });

    setCallInProgress(false);

    if (result?.data?.error_code) {
      toastUpdate(
        "Error",
        result?.data?.user_description,
        true
      );
      return;
    }

    if (selectedProvider === "AU_UPI") {
      dispatch(
        saveUserCurrentPaymentDetails(
          {
            transactionId: result?.data?.orderId,
            amount: amount,
            date: new Date(),
          }
        )
      );
      const token =
        result?.data?.token ||
        result?.data?.paymentToken;

      if (token) {
        window.location.href =
          `https://pay.easebuzz.in/pay/${token}`;
      }
      return;
    }

    setQrData(result?.data);

  } catch (error) {
    setCallInProgress(false);

    toastUpdate(
      "Error",
      error?.message,
      true
    );
  }
};
const handleQRCode = () => {
  setActiveTab("qr");
  initiatePayment("AU_QRCODE");
};

const handleUPI = () => {
  setActiveTab("upi");
  initiatePayment("AU_UPI");
};
useEffect(() => {
  if (
    provider?.includes("AU_QRCODE")
  ) {
    handleQRCode();
  }
}, []);
return (
  <Grid container className={classes.container}>
    <Grid item xs={12}>
      <SubHeader
        label="Payment Options"
        cancelButtonUrl={"/PayNow"}
      />
    </Grid>

    <Grid item xs={12}>
      <Paper className={classes.paymentCard}>
        <div className={classes.header}>
          <Typography variant="h5">
            Complete Payment
          </Typography>
        </div>

        <div className={classes.amountCard}>
          <Typography>
            Amount Payable
          </Typography>

          <Typography
            className={classes.amountValue}
          >
            ₹{amount}
          </Typography>
        </div>

        <Grid
          container
          spacing={2}
          className={classes.tabContainer}
        >
          {provider.includes(
            "AU_QRCODE"
          ) && (
            <Grid item xs={6}>
              <Button
                fullWidth
                startIcon={
                  <CenterFocusWeakIcon />
                }
                className={
                  activeTab === "qr"
                    ? classes.activeButton
                    : classes.inactiveButton
                }
                onClick={handleQRCode}
              >
                QR CODE
              </Button>
            </Grid>
          )}

          {provider.includes(
            "AU_UPI"
          ) && (
            <Grid item xs={6}>
              <Button
                fullWidth
                startIcon={<PaymentIcon />}
                className={
                  activeTab === "upi"
                    ? classes.activeButton
                    : classes.inactiveButton
                }
                onClick={handleUPI}
              >
                UPI PAYMENT
              </Button>
            </Grid>
          )}
        </Grid>

        {activeTab === "qr" &&
          qrData && (
            <div
              className={classes.qrWrapper}
            >
              {qrData?.qrPath ?
              <img
                src={
                  qrData?.qrPath
                }
                alt="QR"
                className={
                  classes.qrImage
                }
              />
              :
              <QRCodeSVG
                  value={qrData?.url}
                  size={250}
                  includeMargin={true}
                />
              }
              <Typography>
                Scan using any UPI app
              </Typography>
            </div>
          )}

        <Grid
          container
          spacing={2}
          style={{ padding: 20 }}
        >
          <Grid item xs={4}>
            <Paper
              className={
                classes.infoCard
              }
            >
              <FlashOnIcon />
              <Typography>
                Instant
              </Typography>
            </Paper>
          </Grid>

          <Grid item xs={4}>
            <Paper
              className={
                classes.infoCard
              }
            >
              <SecurityIcon />
              <Typography>
                Secure
              </Typography>
            </Paper>
          </Grid>

          <Grid item xs={4}>
            <Paper
              className={
                classes.infoCard
              }
            >
              <VerifiedUserIcon />
              <Typography>
                Verified
              </Typography>
            </Paper>
          </Grid>
        </Grid>

        <Box className={classes.footer}>
          🔒 Payments protected with
          bank-grade security
        </Box>
      </Paper>
    </Grid>

    {callInProgress && (
      <CircularProgresss
        callInProgress={
          callInProgress
        }
      />
    )}

    {toast && (
      <ToastModal
        toastMessage={toastMessage}
        toastMessageType={
          toastMessageType
        }
        toastUpdate={toastUpdate}
      />
    )}
  </Grid>
);
}

export default PaymentOptions